import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';

import DashboardShellLayout from './dashboard/DashboardShellLayout';
import DashBoardLayout from './dashboard/DashBoardLayout';
import ExportConfigurator from './export/ExportConfigurator';
import OtherPageLayout from './OtherPageLayout';
import CurrentUser from './current-user/CurrentUser';
import Admin from './admin/Admin';
import DeviceBoardLayout from './device/DeviceBoardLayout';

function Body() {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
            <Routes>
                <Route path="/" element={<DashboardShellLayout />}>
                    <Route index element={<DashBoardLayout />} />
                    <Route path="device/:id" element={<DeviceBoardLayout />} />
                </Route>
                <Route path="export" element={<ExportConfigurator />} />
                <Route path="/" element={<OtherPageLayout />}>
                    <Route path="user" element={<CurrentUser />} />
                    <Route path="admin" element={<Admin />} />
                </Route>
            </Routes>
        </LocalizationProvider>
    );
}

//=================================================================================================
function Router() {
    return (
        <BrowserRouter>
            <Body />
        </BrowserRouter>
    );
}

export default Router;
